import { DecimalPipe } from "@angular/common";
import { inject, Injectable } from "@angular/core";
import { ColumnDefinition, ExcelService, get } from "@malirang/front-share";
import dayjs from "dayjs";

@Injectable({ providedIn: "root" })
export class ExcelExportService {
    private readonly excelService = inject(ExcelService);

    /**
     * @description Excel로 내보낼 데이터를 세팅합니다.
     * @returns { Array<any> }
     */
    private getExportData(data: any[], columns: ColumnDefinition[]) {
        const array = data.map((item, i) => {
            const temp = {} as any;
            for (const [index, column] of columns.entries()) {
                if (column.name === "순번") {
                    // 순번은 1부터 시작하도록 처리
                    temp[column.name] = data.length - i;
                    continue;
                }

                const __value = get(item, column.field, "");

                // formatter 처리
                const _value = column?.formatter
                    ? column.formatter!(__value, item)
                    : __value;

                // pipe 처리
                let value = column?.pipe
                    ? column.pipe!.transform(_value)
                    : _value;

                switch (column.type) {
                    case "number": {
                        value = new DecimalPipe("en-US").transform(value);
                        break;
                    }
                    case "date": {
                        value = dayjs(value).format(
                            column.format || "YYYY-MM-DD",
                        );
                        break;
                    }
                    case "boolean": {
                        value = value
                            ? column.badgeProps?.["true"]?.text || "Yes"
                            : column.badgeProps?.["false"]?.text || "No";
                        break;
                    }
                }

                temp[column.name] = value;
            }

            return temp;
        });

        return array.filter((item) => item);
    }

    exportExcel(data: any[], columns: ColumnDefinition[]) {
        const exportData = this.getExportData(data, columns);
        this.excelService.exportAsExcelFile(exportData);
    }

    exportExcelWithGrouping(
        data: any[],
        columns: ColumnDefinition[],
        groupBy: (item: any) => string,
    ) {
        const groups: Record<string, any[]> = {};

        for (const item of data) {
            const groupName = groupBy(item);
            if (!groups[groupName]) {
                groups[groupName] = [];
            }
            groups[groupName].push(item);
        }

        const sheets = Object.entries(groups).map(([name, groupData]) => ({
            name,
            data: this.getExportData(groupData, columns),
        }));

        this.excelService.exportAsExcelFileMultiSheet(sheets);
    }
}
